/* Small progressive enhancements. Shopify owns variants, prices, cart and subscription billing. */
(() => {
  const selector = '.lc-search, .lc-mobile-menu, .lc-nav-dropdown';
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const details = event.target.closest('.lc-nav-dropdown[open], .lc-search[open], .lc-mobile-menu[open]');
    if (details) { details.open = false; details.querySelector('summary').focus(); }
  });
  document.addEventListener('click', event => {
    document.querySelectorAll(selector).forEach(details => {
      if (details.open && !details.contains(event.target)) details.open = false;
    });
  });
  document.addEventListener('toggle', event => {
    const current = event.target;
    if (!current.matches(selector) || !current.open) return;
    document.querySelectorAll(selector).forEach(details => {
      if (details !== current && !details.contains(current) && !current.contains(details)) details.open = false;
    });
  }, true);
})();
